<div class="chart-card">
  <img
    src="../../../../assets/images/training-quizzes/nodata-img.svg"
    class="no-data"
  />
  <h5 class="justify-content-center">{{ errorMessage }}</h5>
</div>
